module.exports = __webpack_public_path__ + "img/qr_join.3db235b4.png";